module.exports = __webpack_public_path__ + "img/activities-3.ac9df0b4.jpg";